<template>
  <v-form>
    <div style="min-height:350px;">

      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-alert :value="true" type="info" outlined color="secondary">
            Al activar tu <b>perfil público</b> en <b>{{ appName }}</b>, activaremos un link para que puedas compartirlo con tu público objetivo y así puedan conocer mas sobre tu negocio, agendar horas, ver tus datos de contacto y más!
          </v-alert>
          <v-alert :value="publicProfileErrors.length > 0" type="error" outlined color="error">
            Para activar tu perfil público, antes necesitas resolver los siguientes conflictos:

            <ul class="mt-2">
             <li v-for="(err, i) in publicProfileErrors" :key="i" v-html="err" />
            </ul>
          </v-alert>

          <v-alert :value="advices.length > 0" type="error" outlined color="primary">
            Consejos:

            <ul class="mt-2">
              <li v-for="(advice, i) in advices" :key="i" v-html="advice" />
            </ul>
          </v-alert>


        </v-flex>
        <v-flex xs12 my-3>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 md3>
          <v-switch class="ml-auto"
              :disabled="!allowPublicProfile"
              :hint="publicProfileHint"
              persistent-hint
              v-model="settings.enable_public_profile"
              label="Activar perfil público" />
        </v-flex>
        <v-flex class="hidden-sm-and-down" xs12 md1 text-right pr-4>
          <v-divider vertical></v-divider>
        </v-flex>
        <v-flex xs12 md8 text-center>
          <slug-picker
              ref="slugPicker"
              label="Escoge un alias para tu link"
              required
              share-btn
              :disabled="!settings.enable_public_profile"
              :default-name="settings.alias"
              :default-slug="settings.slug"
              @change:name="settings.alias = $event"
              @change:slug="settings.slug = $event"
          />
        </v-flex>

      </v-layout>

      <cover-picker
          :max-size="2"
          class="ma-3"
          @change:validation="validCover = $event"
          @change="settings.cover_file = $event"
          img-label="Seleccionar portada"
          :default="settings.cover_image">
        <template v-slot:avatar>
          <image-picker
              :max-size="2"
              class="ma-3"
              @change:validation="validImage = $event"
              @change="settings.avatar_file = $event"
              img-label="Seleccionar logo"
              :default="settings.avatar_image" />
        </template>
      </cover-picker>

      <v-text-field
        v-if="institution"
        class="pt-0"
        outlined
        label="Nombre de la Institución"
        v-model="settings.name"
        :rules="requiredRules"
      ></v-text-field>

      <v-textarea
        :rows="4"
        outlined
        clearable
        label="Descripción"
        v-model="settings.description"
        maxlength="150"
        counter="150"
      ></v-textarea>

    </div>

    <v-form v-model="isRRSSValid">
      <v-layout wrap>
        <v-flex xs12 my-2>
          <div class="subtitle">Redes Sociales</div>
          <v-divider></v-divider>
        </v-flex>

        <v-flex xs12 md4 pa-1>
          <v-text-field
              v-model="settings.facebook_url"
              prepend-inner-icon="fab fa-facebook-square"
              placeholder="Ej. https://facebook.com/yo"
              label="Perfil de Facebook"
              :rules="facebookRules"
              clearable
              outlined
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <v-text-field
              v-model="settings.instagram_url"
              prepend-inner-icon="fab fa-instagram"
              placeholder="Ej. https://instagram.com/yo"
              label="Perfil de Instagram"
              :rules="instagramRules"
              clearable
              outlined
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <v-text-field
              v-model="settings.linkedin_url"
              prepend-inner-icon="fab fa-linkedin"
              placeholder="Ej. https://linkedin.com/in/yo"
              label="Perfil de LinkedIn"
              :rules="linkedInRules"
              clearable
              outlined
          />
        </v-flex>
        <v-flex xs12 md4></v-flex>

      </v-layout>
    </v-form>



    <div class="text-right">
      <v-btn
        color="primary"
        :disabled="!isRRSSValid || !publicProfileValid || publicProfileErrors.length > 0"
        @click="submit"
        :loading="loading"
        >Guardar</v-btn>
    </div>
  </v-form>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import {mapState, mapMutations, mapGetters} from 'vuex'
import ImagePicker from "@/components/common/ImagePicker";
import CoverPicker from "@/components/common/CoverPicker";
import SlugPicker from "@/components/providers/settings/SlugPicker";

export default {
  components: {SlugPicker, CoverPicker, ImagePicker},
  props: {
    submitFn: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      validImage: true,
      validCover: true,
      isRRSSValid: true,
      settings: {
        name: null,
        description: '',
        alias: '',
        slug: '',
        cover_image: null,
        cover_file: null,
        avatar_image: null,
        avatar_file: null,
        enable_public_profile: false,
        facebook_url: '',
        instagram_url: '',
        linkedin_url: ''
      },
      requiredRules: [v => !!v || 'Campo Requerido'],
      facebookRules: [
          v => !v || (!!v && Boolean(v.match(/^https?:\/\/(www\.)?facebook.com\/.+/))) || 'Url inválida'
      ],
      instagramRules: [
          v => !v || (!!v && Boolean(v.match(/^https?:\/\/(www\.)?instagram.com\/.+/))) || 'Url inválida'
      ],
      linkedInRules: [
          v => !v || (!!v && Boolean(v.match(/^https?:\/\/(www\.)?linkedin.com\/(in\/)?.+/))) || 'Url inválida'
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    ...mapState(['currentUser', 'currentProvider']),
    ...mapGetters(['allowPublicProfile']),
    publicProfileHint(){
      const vm = this
      if(vm.allowPublicProfile) return ''
      return 'El plan actual no incluye perfil público'
    },
    advices(){
      const vm = this
      return [] // todo add config advices
    },
    publicProfileErrors(){
      const vm = this
      let errors = []

      if(!vm.settings.enable_public_profile){
        return []
      }

      if(!vm.settings.description){
        errors.push('Debes agregar una descripción')
      }

      if(vm.institution){
        if(!vm.mainOffice){
          errors.push('Debes <a href="/panel/provider/branches">configurar sucursales</a>')
        }
      }else{
        if(!vm.currentUser.phone1){
          errors.push(`Debes <a href="/panel/user/info">completar tus datos</a>`)
        }
      }

      return errors

    },
    mainOffice(){

      const vm = this

      if(!vm.currentProvider || !vm.currentProvider.institution) return null

      let {branch_offices} = vm.currentProvider.institution
      let mainOffice = branch_offices.find(office => office.main)
      if(!mainOffice && branch_offices.length > 0){
        mainOffice = branch_offices[0]
      }

      return mainOffice

    },
    publicProfileValid(){
      const vm = this
      return !!(vm.settings.enable_public_profile && vm.settings.slug) ||
          !vm.settings.enable_public_profile
    },
    institution() {
      var vm = this
      return !!vm.currentProvider && vm.currentProvider.institution || null
    }
  },
  methods: {
    loadData() {
      var vm = this
      const {
        settings: {
          avatar_image,
          cover_image,
          enable_public_profile,
          facebook_url,
          instagram_url,
          linkedin_url,
        },
        institution,
        description,
        alias,
        slug
      } = vm.currentProvider

      vm.settings.name = institution && institution.name || ''
      vm.settings.description = description
      vm.settings.avatar_image = avatar_image
      vm.settings.cover_image = cover_image
      vm.settings.enable_public_profile = enable_public_profile
      vm.settings.slug = slug
      vm.settings.alias = alias || (institution && institution.name) || ''
      vm.settings.facebook_url = facebook_url
      vm.settings.instagram_url = instagram_url
      vm.settings.linkedin_url = linkedin_url

      vm.$nextTick(function(){
        vm.$refs.slugPicker.setDefaults()
      })

    },
    async submit() {

      var vm = this
      const { id } = vm.currentProvider

      let payload = {
          institution_name: vm.institution ? vm.settings.name : null,
          description: vm.settings.description,
          enable_public_profile: vm.settings.enable_public_profile  ? 1 : 0,
          facebook_url: vm.settings.facebook_url,
          instagram_url: vm.settings.instagram_url,
          linkedin_url: vm.settings.linkedin_url,
      }

      if(vm.settings.enable_public_profile){
        payload.alias = vm.settings.alias
        payload.slug = vm.settings.slug
      }

      if(vm.settings.avatar_file){
        payload.avatar = vm.settings.avatar_file
      }

      if(vm.settings.cover_file){
        payload.cover = vm.settings.cover_file
      }

      this.loading = true
      const response = await ApiUtils.makePatch(`provider/${id}/settings`, null, payload)
      if (response.ok){
        await ApiUtils.fetchMe()
        vm.toast('Cambios guardados correctamente')
      }
      this.loading = false

    }
  },
  watch:{
    currentProvider(){
      this.loadData()
    }
  }
}
</script>
